import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/quizzes',
        component: () => import('@/pages/quizzes/QuizzesIndex.vue'),
        props: true,
        children: [
            {
                name: 'quizzes-index',
                path: '',
                component: () => import('@/components/quizzes/QuizzesView.vue'),
                meta: {
                    title: 'Quizzes',
                    dataTablePage: true,
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view all', subject: 'quizzes' },
                },
                props: true,
            },

            {
                name: 'quizzes-index-archive',
                path: '/quizzes/archive',
                component: () => import('@/components/quizzes/QuizzesView.vue'),
                meta: {
                    title: 'Archived Quizzes',
                    dataTablePage: true,
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('archive a quiz'),
                },
                props: true,
            },
        ],
    },

    {
        path: '/quizzes/import',
        name: 'quiz-import',
        component: () => import('@/pages/quizzes/ImportQuiz.vue'),
        meta: {
            middleware: [GateKeeperMiddleware],
            ability: { action: 'create', subject: 'quiz' },
        },
        props: true,
    },

    {
        path: '/quizzes/:quizId',
        name: 'quiz-view',
        component: () => import('@/pages/quizzes/QuizView.vue'),
        meta: {
            middleware: [GateKeeperMiddleware],
            ability: [{ action: 'view', subject: 'quiz' }],
        },
        props: true,
        children: [
            {
                path: 'read-only',
                name: 'quiz-read-only',
                component: () => import('@/pages/quizzes/QuizView.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view', subject: 'quiz' },
                },
            },
            {
                path: 'report',
                name: 'quiz-report',
                component: () => import('@/pages/quizzes/QuizView.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view', subject: 'quiz report' },
                },
            },
            {
                path: 'evaluation-report',
                name: 'evaluation-report',
                component: () => import('@/pages/quizzes/QuizView.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view', subject: 'quiz report' },
                },
            },
            {
                path: 'version',
                name: 'quiz-version',
                component: () => import('@/pages/quizzes/QuizView.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view all', subject: 'versions' },
                },
            },
            {
                path: 'usages',
                name: 'quiz-usages',
                component: () => import('@/pages/quizzes/QuizView.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: {
                        action: 'view',
                        subject: 'quiz activity usages',
                    },
                },
            },
            {
                path: 'deployments',
                name: 'survey-deployments',
                component: () => import('@/pages/quizzes/QuizView.vue'),
                props: true,
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: {
                        action: 'view all',
                        subject: 'automated surveys',
                    },
                    dataTablePage: true,
                },
                children: [
                    {
                        path: ':automatedSurveyId',
                        component: () => import('@/pages/quizzes/QuizView.vue'),
                        meta: {
                            middleware: [GateKeeperMiddleware],
                            ability: {
                                action: 'view all',
                                subject: 'automated surveys',
                            },
                            dataTablePage: false,
                        },
                        props: route => ({
                            ...route.params,
                            automatedSurveyId: Number.parseInt(route.params.automatedSurveyId, 10),
                        }),
                        children: [
                            {
                                path: 'details',
                                name: 'survey-deployment-details',
                                component: () => import('@/pages/quizzes/QuizView.vue'),
                                meta: {
                                    middleware: [GateKeeperMiddleware],
                                    ability: {
                                        action: 'view all',
                                        subject: 'automated surveys',
                                    },
                                    dataTablePage: false,
                                },
                            },
                            {
                                path: 'people',
                                name: 'survey-deployment-people',
                                component: () => import('@/pages/quizzes/QuizView.vue'),
                                meta: {
                                    middleware: [GateKeeperMiddleware],
                                    ability: {
                                        action: 'view all',
                                        subject: 'automated surveys',
                                    },
                                    dataTablePage: false,
                                },
                            },
                            {
                                path: 'responses',
                                name: 'survey-deployment-responses',
                                component: () => import('@/pages/quizzes/QuizView.vue'),
                                meta: {
                                    middleware: [GateKeeperMiddleware],
                                    ability: {
                                        action: 'view all',
                                        subject: 'automated surveys',
                                    },
                                    dataTablePage: false,
                                },
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
